import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Label, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';
import PermissionWrapper from '../../auth/PermissionWrapper';

class AdminClients extends Component {

  standardRow = (client) => {
    this.props.info('AdminClients.js/standardRow (client)', client);
    return (<Row className="adminRow pointer" onClick={() => this.props.onEdit(client.id)}>
      <Col md={6} className="text-left">
        {<FontAwesomeIcon icon={(client['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((client['active']) ? 'iconActive' : 'iconInactive')} />}
        {client['client']}
      </Col>
      <Col md={6} className="text-left">
        {client.customerNumber}
      </Col>
    </Row>
    )
  }

  editRow = (client) => {
    this.props.log('AdminClients.js/editRow (client)', client);
    return (
      <Row className="editRow adminRow activeTab">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="pr-2">
              <Input
                placeholder="Client"
                type="text"
                id="client-edit"
                name="client"
                value={this.props.isFieldNull(this.props.editClient.client)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2">
              <Input
                placeholder="Customer Number"
                type="text"
                id="client-edit-customer-number"
                name="customerNumber"
                value={this.props.isFieldNull(this.props.editClient.customerNumber)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"edit-client-active" + client.id}
                name="active"
                checked={this.props.isFieldNull(this.props.editClient.active, true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"edit-client-active" + client.id}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={4} className="text-right">
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Clients">
            <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Company">
              <FontAwesomeIcon icon={faCheck} />
            </Button>
          </PermissionWrapper>
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Clients">
            <ConfirmButton className="mx-1" color="danger" onClick={() => this.props.onDelete(client.id)} title="Delete Company">
              <FontAwesomeIcon icon={faTrashAlt} />
            </ConfirmButton>
          </PermissionWrapper>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col md={6} className="text-right p-3">
          Assigned Users
          <div className="mt-3">
            <Label for={"userClients_all"}>
              <Input
                type="checkbox"
                name="roles"
                id={"userClients_all"}
                checked={this.props.editClient.users.length === this.props.users.length}
                onChange={e => {
                  this.props.onSelectAll(e, {
                    type: 'users',
                    typeKey: 'auth0',
                    target: 'editClient',
                  });
                  this.props.onSelectAll(e, {
                    type: 'clients',
                    target: 'users',
                    filterType: 'editClient',
                    filterKey: 'id',
                  })
                }}
              />
              Select All
            </Label>
          </div>
        </Col>
        <Col md={6} className="text-left py-3 pl-5 maxHpanel">
          {this.props.users.map(user => (
            <div key={user.auth0}><Label for={"user_" + user.auth0}>
              <Input
                type="checkbox"
                name="users"
                id={"userClient_" + user.auth0 + "_" + client.id}
                checked={this.props.isFieldNull(this.props.editClient.users.findIndex(i => i === user.auth0) > -1, true)}
                onChange={e => this.props.onChange(e, 'edit')}
              />
              {user['lastName'] + ', ' + user['firstName']}
            </Label></div>
          ))}
        </Col>
      </Row>
    )
  }

  addRow = () => {
    this.props.info('AdminClients.js/addRow');
    return (
      <Row className="py-4 text-left align-items-bottom ">
        <Col>
          <Form inline>
            {/* <FormGroup className="pr-2">
              Add New Company
            </FormGroup> */}
            <FormGroup className="px-2">
              <Input
                placeholder="New Company"
                type="text"
                id="client-add"
                name="client"
                value={this.props.isFieldNull(this.props.newClient.client)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Customer Number"
                type="text"
                id="client-add-customer-number"
                name="customerNumber"
                value={this.props.isFieldNull(this.props.newClient.customerNumber)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"client-active"}
                name="active"
                checked={this.props.isFieldNull(this.props.newClient.active, true)}
                onChange={e => this.props.onChange(e)} />
              <Label for={"client-active"}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={3} className="text-right">
          <Button
            disabled={this.props.newClient.client === ''}
            color="primary"
            onClick={this.props.handleAdd}
          >Add Company</Button>
        </Col>
      </Row>
    )
  }

  render() {
    this.props.info('AdminClients.js/render');
    return (
      <Container className="adminContainer" fluid>
        <Row className="adminRow text-left font-weight-bold">
          <Col md={6}>
            Company Name
          </Col>
          <Col md={6}>
            Customer Number
          </Col>
        </Row>
        {this.props.clients.map(client => (
          <Fragment key={client.id}>{this.props.editClient.id === client.id ? this.editRow(client) : this.standardRow(client)}</Fragment>
        ))}
        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Clients">
          {this.addRow()}
        </PermissionWrapper>
      </Container>
    );
  }
}

export default AdminClients;